import { Pipe, PipeTransform } from '@angular/core';

import { getFormattedTimezone } from '../../utils';

@Pipe({
  name: 'rtFormatTimezone',
  standalone: true,
})
export class FormatTimezonePipe implements PipeTransform {
  public transform = getFormattedTimezone;
}
